// MUI
import { Button } from '@mui/material';

interface Props {
  isLoading: boolean;
  isSubmitting: boolean;
  text: string;
}

const WelcomeActionButton = ({ isLoading, isSubmitting, text }: Props) => {
  return (
    <Button
      loading={isLoading || isSubmitting}
      disabled={isSubmitting}
      type="submit"
      sx={{
        backgroundColor: '#1DB0BF',
        color: '#FFFFFF',
        width: '100%',
        height: '100%',
        fontWeight: 'bold',
        '&:hover': { backgroundColor: '#1D6F78' },
      }}
    >
      {text}
    </Button>
  );
};

export { WelcomeActionButton };